var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 7.60156C14.8 7.15973 15.1582 6.80156 15.6 6.80156H16.4C17.2837 6.80156 18 7.51791 18 8.40156V14.8016C18 15.6852 17.2837 16.4016 16.4 16.4016H5.2C4.31634 16.4016 3.6 15.6852 3.6 14.8016V12.4016C3.6 11.9597 3.95817 11.6016 4.4 11.6016C4.84183 11.6016 5.2 11.9597 5.2 12.4016V14.8016H16.4V8.40156H15.6C15.1582 8.40156 14.8 8.04339 14.8 7.60156Z",
    fill: "#3CAE8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.20156C2 4.31791 2.71634 3.60156 3.6 3.60156H14.8C15.6837 3.60156 16.4 4.31791 16.4 5.20156V11.6016C16.4 12.4852 15.6837 13.2016 14.8 13.2016H3.6C2.71634 13.2016 2 12.4852 2 11.6016V5.20156ZM14.8 5.20156L3.6 5.20156V11.6016H14.8V5.20156Z",
    fill: "#3CAE8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2 7.60156C8.75817 7.60156 8.4 7.95973 8.4 8.40156C8.4 8.84339 8.75817 9.20156 9.2 9.20156C9.64183 9.20156 10 8.84339 10 8.40156C10 7.95973 9.64183 7.60156 9.2 7.60156ZM6.8 8.40156C6.8 7.07608 7.87452 6.00156 9.2 6.00156C10.5255 6.00156 11.6 7.07608 11.6 8.40156C11.6 9.72705 10.5255 10.8016 9.2 10.8016C7.87452 10.8016 6.8 9.72705 6.8 8.40156Z",
    fill: "#3CAE8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordPayment);
export default __webpack_public_path__ + "static/media/record-payment.afffda8aff3beda06f98de893ec784c1.svg";
export { ForwardRef as ReactComponent };